/* eslint-disable no-unused-vars */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import { ButtonV2 } from '@zola/zola-ui';

import { RenderField, RenderSubmitButton } from '../../../common/form';
import { getTotalNumberOfSeats } from '../../../../selectors/seatingchart/SeatingChartSelector';
import * as Validations from '../../../common/form/commonValidations';
import { updateTables } from '../../../../actions/SeatingChartActions';
import { showModal } from '../../../../actions/ModalActions';
import { normalizeValueInRange } from '../../../common/form/commonNormalizations';
import Loader from '../../../common/ui/Loader';
import './TableModal.less';

const seatValidation = (value, props, formProps) => {
  const numFilledSeats = formProps.table.num_filled_seats;

  if (value < numFilledSeats) {
    return `Please enter a number equal to or larger than the number of guests (${numFilledSeats}) currently seated at the table.`;
  }
  return undefined;
};

const maxSeatValidation = (value, props, formProps) => {
  if (value + (formProps.totalNumSeats - formProps.initialValues.num_seats) > 750) {
    return "You've gone over the max limit of 750 seats!";
  }

  return undefined;
};

const EditTableModal = ({
  handleSubmit,
  pristine,
  submitting,
  valid,
  onDelete,
  table,
  totalNumSeats,
  initialValues,
}) => (
  <div>
    <div className="modal-header">
      <h3 className="modal-title">Edit Table</h3>
    </div>
    <form onSubmit={handleSubmit} id="table-form" className="tableModal" noValidate>
      <Field
        component={RenderField}
        name="name"
        label="Table Name"
        type="text"
        id="event-name"
        placeholder="Table"
        required
        validate={[Validations.REQUIRED, Validations.MAX_LENGTH_50]}
      />
      <Field
        component={RenderField}
        name="num_seats"
        label="Number of Seats"
        type="number"
        id="event-name"
        placeholder="8"
        validate={[Validations.REQUIRED, seatValidation, maxSeatValidation]}
        normalize={normalizeValueInRange(1, 99)}
        required
      />
      {submitting ? (
        <Loader />
      ) : (
        <div className="tableModal__buttonGroup">
          <ButtonV2
            variant="tertiary"
            className="tableModal__delete-form"
            onClick={() => onDelete(table)}
          >
            Delete Table
          </ButtonV2>
          <RenderSubmitButton
            className="tableModal__saveBtn"
            pristine={pristine}
            submitting={submitting}
            disabled={submitting}
            valid={valid}
          />
        </div>
      )}
    </form>
  </div>
);

EditTableModal.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  pristine: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,
  valid: PropTypes.bool.isRequired,
  initialValues: PropTypes.shape({
    name: PropTypes.string,
    num_seats: PropTypes.number,
  }),
  onDelete: PropTypes.func,
  table: PropTypes.shape({
    name: PropTypes.string,
    num_seats: PropTypes.number,
  }),
  totalNumSeats: PropTypes.number,
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  onSubmit: createTaskRequest => {
    const tableList = [];
    const newTable = ownProps.table;
    newTable.name = createTaskRequest.name;
    newTable.num_seats = createTaskRequest.num_seats;
    tableList.push(newTable);

    return dispatch(updateTables(tableList, true)).then(() => {
      ownProps.hideModalFn();
    });
  },
  onDelete: table => dispatch(showModal('DELETE_TABLE_MODAL', { table }, { size: 'sm' })),
});

const mapStateToProps = (state, ownProps) => ({
  initialValues: {
    name: ownProps.table.name,
    num_seats: ownProps.table.num_seats,
  },
  totalNumSeats: getTotalNumberOfSeats(state.seatingChart),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  reduxForm({
    form: 'EditTableModal',
  })(EditTableModal)
);



// WEBPACK FOOTER //
// ./src/components/manage/seatingchart/Modals/EditTable.jsx